import React, { useContext } from "react";

import { useLocalContent } from "~/sdks/LocalContent/context";

import type { CommuteData } from "~/sdks/LocalContent/hooks/useCommute/types";
import type { CommuteOptions } from "~/sdks/LocalContent/types";

export type DefaultContext = {
  isOpen: boolean;
  commuteOptions: CommuteOptions;
  commuteData: CommuteData | null;
  isCommuteDataLoading: boolean;
  distanceUnit?: "metric" | "imperial";
  onToggleIsOpen: () => void;
  handleCalculateCommute: (options: CommuteOptions) => void;
};

const RootElementContext = React.createContext<DefaultContext>(
  {} as DefaultContext
);
const useRootElement = () => useContext(RootElementContext);

const RootElementContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const {
    isCommuteCalculatorOpen,
    commuteData,
    commuteOptions,
    isCommuteDataLoading,
    distanceUnit = "metric",
    handleToggleIsCommuteCalculatorOpen,
    handleCalculateCommute,
  } = useLocalContent();

  return (
    <RootElementContext.Provider
      value={{
        isOpen: isCommuteCalculatorOpen,
        commuteData,
        commuteOptions,
        isCommuteDataLoading,
        distanceUnit,
        onToggleIsOpen: handleToggleIsCommuteCalculatorOpen,
        handleCalculateCommute,
      }}
    >
      {children}
    </RootElementContext.Provider>
  );
};

export { useRootElement, RootElementContextProvider };
